import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CertbyrutComponent } from './certbyrut.component';

const routes: Routes = [{ path: '', component: CertbyrutComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CertbyrutRoutingModule { }
